// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import VueAwesomeSwiper from 'vue-awesome-swiper'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
// import 'swiper/dist/css/swiper.min.css'

// 公用css
import '../src/assets/css/common.css'
import '../src/assets/css/swiper.min.css'
import 'video.js/dist/video-js.css'
import animate from "animate.css"
Vue.use(animate)

import AnalysysAgent from "../src/assets/sdk/AnalysysAgent_JS_SDK.es6.min.js";
import "../src/assets/sdk/AnalysysAgent_GBK.es6.min.js";
import "../src/assets/sdk/AnalysysAgent_Encrypt.es6.min.js";
import "../src/assets/sdk/AnalysysAgent_PageViewStayTime.es6.min.js";
import "../src/assets/sdk/AnalysysAgent_ExposurePoint.es6.min.js";
// import "../src/assets/sdk/js/yiguan_init.js";
// AnalysysAgent.init({
//   appkey: "0a05d32ea2c2de69", //APPKEY
//   debugMode: 2,
//   uploadURL: "https://ubaxhjycloud.analysysdata.com",
//   visitorConfigURL: "https://ubaxhjycloud.analysysdata.com",
//   SDKFileDirectory: "./js/sdk/",
//   encryptType: 2,
//   exposure: {
//     valid_time: 300,//停留有效时间
//     property: {
//       cc: function () {
//         return +new Date()
//       }
//     },//自定义参数
//     exposure_click: true, // 是否自动采集曝光元素点击事件
//     multiple: 5000,//true或毫秒值, 是否重复采集曝光点数据或多少毫秒后可再次采集
//     element_list: function () {
//       var list = [].slice.call(document.getElementsByTagName('a'), 0)
//       var spanList = [].slice.call(document.getElementsByTagName('span'), 0)
//       list.push.apply(list, spanList)
//       return list
//     }
//   }
//   /**如无自定义配置，则与uploadURL相同**/
// });
// Vue.prototype.AnalysysAgent = AnalysysAgent

// 公用js
// import common from'../src/assets/js/common.js'
import common from'../src/assets/js/common1.js'
Vue.prototype.common = common

import axios from 'axios'
import VueAxios from 'vue-axios'
Vue.use(VueAxios,axios)

import VueCookies from 'vue-cookies'
Vue.use(VueCookies)

import Video from 'video.js'
Vue.prototype.$video = Video

// 图片懒加载
import VueLazyLoad from 'vue-lazyload'
Vue.use(VueLazyLoad,{
    preLoad: 1.3,
    error:'./static/error.png',
    loading:'./static/loading.png',
    attempt: 1
})

Vue.use(ElementUI)

Vue.use(VueAwesomeSwiper)

Vue.config.productionTip = false

// 路由页面转换在头部
router.afterEach((to,from,next) => {
  window.scroll(0, 0);
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>',
  render: h => h(App)
})



// WEBPACK FOOTER //
// ./src/main.js